// wallpaper-calculator.js — Pipeline Theme Dynamic Price Fix
(function () {

  function fmt2(n)  { return parseFloat(n.toFixed(2)); }
  function mToFt(m) { return fmt2(m * 3.28084); }



  /* ─── GALLERY IMAGE SWITCHER ─────────────────────── */
  window.wpSetMain = function(img) {
    var mainImg = document.getElementById('wp-main-img');
    if (mainImg && img.dataset.full) {
      mainImg.src = img.dataset.full;
    }
    document.querySelectorAll('.wp-thumb').forEach(function(t) {
      t.classList.remove('active');
    });
    img.classList.add('active');
  };

  /* ─── QTY ────────────────────────────────────────── */
  window.wpQty = function(delta) {
    var inp = document.getElementById('wp-qty-val');
    if (!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value) || 1) + delta);
  };


  /* ─── APIPPA KILLER ─────────────────────────────── */
  function killApippa() {
    window.CustomPriceCalculator = undefined;
    window.apippa = undefined;
    window.cpp    = undefined;

    if (!window._wpXHRPatched) {
      window._wpXHRPatched = true;
      var _origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        if (typeof url === 'string' && /custompricecalculator/i.test(url))
          arguments[1] = 'about:blank';
        return _origOpen.apply(this, arguments);
      };
    }

    if (!window._wpFetchPatched) {
      window._wpFetchPatched = true;
      var _orig = window.fetch;
      window.fetch = function (url, opts) {
        if (typeof url === 'string' && /custompricecalculator/i.test(url))
          return Promise.resolve(new Response('{}', { status: 200 }));
        return _orig.apply(this, arguments);
      };
    }
  }

  /* ─── DYNAMIC ADD TO CART ──────────────────────── */
  function addToCart(variantId, calculatedTotal, btn) {
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled    = true;

    // image_83a77f.png ke format ke mutabiq values uthana
    var wallH = document.getElementById('wp-height').options[document.getElementById('wp-height').selectedIndex].text;
    var wallW = document.getElementById('out-w-m').textContent + ' m | ' + document.getElementById('out-w-ft').textContent + ' ft';
    var panels = document.getElementById('out-panels').textContent;
    var panelWidthDisplay = document.getElementById('out-bw-m').textContent + ' m | ' + document.getElementById('out-bw-ft').textContent + ' ft';
    var areaDisplay = document.getElementById('out-area-m').textContent + ' m² | ' + document.getElementById('out-area-ft').textContent + ' ft²';
    
    // Exact label from image_83a77f.png
    var finalTotalDisplay = document.getElementById('out-total').textContent;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;

      var item = {};
      try { item = JSON.parse(xhr.responseText); } catch(e) {}

      if (xhr.status === 200 && item.id) {
        btn.textContent       = '✓ Added!';
        btn.style.background  = '#2d6a4f';
        btn.disabled          = false;

        var xhr2 = new XMLHttpRequest();
        xhr2.open('GET', '/cart.js');
        xhr2.setRequestHeader('Accept', 'application/json');
        xhr2.onreadystatechange = function() {
          if (xhr2.readyState !== 4 || xhr2.status !== 200) return;
          var cart = JSON.parse(xhr2.responseText);

          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

          setTimeout(function() {
            var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          }, 150);
        };
        xhr2.send();

        setTimeout(function() {
          btn.textContent = original;
          btn.style.background = '';
        }, 2500);

      } else {
        alert(item.description || 'Error adding to cart.');
        btn.textContent = original;
        btn.disabled = false;
      }
    };

    // image_83a77f.png labels integrated into properties
    var payload = {
      id: Number(variantId),
      quantity: Number(calculatedTotal),
      properties: {
        'Wall Height': wallH,
        'Wall Width': wallW,
        'Requirement': panels + ' panels i.e. ' + panelWidthDisplay,
        'Total billable area': areaDisplay,
        'Total Cost(INR)': finalTotalDisplay
      }
    };

    xhr.send(JSON.stringify(payload));
  }

  /* ─── BIND FORM ──────────────────────────────────── */
  var _bound = false;
  function bindForm() {
    if (_bound) return;
    var form = document.getElementById('wp-form');
    if (!form) return;
    _bound = true;

    var fresh = form.cloneNode(true);
    form.parentNode.replaceChild(fresh, form);

    fresh.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      killApippa();

      var idEl  = fresh.querySelector('[name="id"]');
      var btn   = fresh.querySelector('[name="add"]');
      var total = document.getElementById('out-total').textContent.replace(/,/g, '');

      if (!idEl || !idEl.value) {
        alert('Please select a variant.');
        return;
      }

      addToCart(idEl.value, parseInt(total), btn);
    }, true);
  }

  /* ─── CALCULATOR ────────────────────────────────── */
  window.wpCalc = function () {
    var calc = document.getElementById('wp-calculator');
    if (!calc) return;
    var price  = parseFloat(calc.dataset.price) || 3445;
    var panel  = parseFloat(calc.dataset.panel) || 1.04;
    var hM     = parseFloat(document.getElementById('wp-height').value);
    var wFt    = parseFloat(document.getElementById('wp-width-ft').value);
    var wIn    = parseFloat(document.getElementById('wp-width-in').value);

    var wM     = (wFt * 12 + wIn) * 0.0254;
    var panels = Math.ceil(wM / panel);
    var billW  = panels * panel;
    var areaM  = fmt2(billW * hM);
    var areaFt = fmt2(areaM * 10.7639);

    document.getElementById('out-h-m').textContent     = fmt2(hM);
    document.getElementById('out-h-ft').textContent    = mToFt(hM);
    document.getElementById('out-w-m').textContent     = fmt2(wM);
    document.getElementById('out-w-ft').textContent    = fmt2(wFt + (wIn / 12));
    document.getElementById('out-panels').textContent  = panels;
    document.getElementById('out-bw-m').textContent    = fmt2(billW);
    document.getElementById('out-bw-ft').textContent   = mToFt(billW);
    document.getElementById('out-area-m').textContent  = areaM;
    document.getElementById('out-area-ft').textContent = areaFt;
    
    var finalTotal = Math.round(areaM * price);
    document.getElementById('out-total').textContent   = finalTotal.toLocaleString('en-IN');
  };

  /* ─── BOOT ──────────────────────────────────────── */
  killApippa();
  bindForm();

  document.addEventListener('DOMContentLoaded', function() {
    killApippa();
    bindForm();
    wpCalc();
  });

  window.addEventListener('load', function() {
    killApippa();
    bindForm();
  });

  var retry = setInterval(function() {
    killApippa();
    bindForm();
    if (_bound) clearInterval(retry);
  }, 300);

  /* ─── DYNAMIC PREDICTIVE SEARCH DATA PATCH ──────────────── */
if (!window._wpFetchSearchPatched) {
  window._wpFetchSearchPatched = true;
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    // 1. Agar search query hit ho rahi hai, toh usme metafields request jodenge
    if (typeof url === 'string' && url.includes('/search/suggest') && !url.includes('predictive_search_fields')) {
      // API ko bolenge ki custom metafield data bhi laakar de
      if (url.includes('?')) {
        url += '&resources[options][fields]=title,body,product_type,variants.title,metafields.custom.price_per_sqft';
      } else {
        url += '?resources[options][fields]=title,body,product_type,variants.title,metafields.custom.price_per_sqft';
      }
      arguments[0] = url;
    }

    return originalFetch.apply(this, arguments).then(function (response) {
      if (typeof url === 'string' && url.includes('/search/suggest')) {
        return response.clone().json().then(function (data) {
          if (data.resources && data.resources.results && data.resources.results.products) {
            data.resources.results.products.forEach(function (prod) {
              
              // Check agar product wallpaper hai
              if (prod.url.includes('wallpaper') || prod.title.toLowerCase().includes('wallpaper')) {
                
                // Shopify API se dynamic metafield data read karna
                var metaPrice = null;
                if (prod.metafields && prod.metafields.custom && prod.metafields.custom.price_per_sqft) {
                  metaPrice = prod.metafields.custom.price_per_sqft;
                } else if (prod.metafields && prod.metafields.price_per_sqft) {
                  metaPrice = prod.metafields.price_per_sqft;
                }

                // 2. Agar metafield milta hai toh use dynamic format karein, nahi toh blank na ho isliye fallback rate
                if (metaPrice) {
                  var rawPrice = parseFloat(metaPrice);
                  // Agar data direct array ya string hai toh number format fix karein
                  if (!isNaN(rawPrice)) {
                    prod.price = "Rs. " + rawPrice.toFixed(2) + " / sq. ft.";
                  } else {
                    prod.price = "Rs. " + metaPrice + " / sq. ft.";
                  }
                } else {
                  // Fallback: Agar kisi product me galti se metafield blank chhut gaya ho
                  prod.price = "Price calculated by size";
                }
              }
            });
          }
          return new Response(JSON.stringify(data), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
          });
        }).catch(function() {
          return response;
        });
      }
      return response;
    });
  };
}

})();